(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('.rr-footer').forEach(footer=>{
      if(footer.dataset.ready)return;footer.dataset.ready='true';
      const desktop=window.matchMedia('(min-width:750px)');
      const update=()=>footer.querySelectorAll('details').forEach(d=>d.open=desktop.matches);
      desktop.addEventListener('change',update);update();
    });
    scope.querySelectorAll('[data-rr-carousel]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const track = root.querySelector('[data-rr-track]');
      const dots = root.querySelector('[data-rr-dots]');
      if (!track) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const move = left => track.scrollTo({left, behavior: reduced ? 'auto' : 'smooth'});
      const step = () => root.dataset.step === 'card' ? (track.firstElementChild?.getBoundingClientRect().width || track.clientWidth) : track.clientWidth + parseFloat(getComputedStyle(track).gap || 0);
      const sync = () => {
        if (!dots || !track.clientWidth) return;
        const count = Math.max(1, Math.ceil((track.scrollWidth - track.clientWidth) / step()) + 1);
        if (dots.children.length !== count) {
          dots.replaceChildren();
          for (let i=0;i<count;i++) {
            const button=document.createElement('button');
            button.type='button';button.className='rr-dot';
            button.setAttribute('aria-label', `${root.dataset.pageLabel || 'Slide'} ${i+1}`);
            button.addEventListener('click',()=>move(Math.min(i*step(),track.scrollWidth-track.clientWidth)));
            dots.append(button);
          }
        }
        const max=track.scrollWidth-track.clientWidth;
        const current=track.scrollLeft>=max-2?count-1:Math.round(track.scrollLeft/step());
        [...dots.children].forEach((dot,i)=>dot.setAttribute('aria-current',String(i===current)));
      };
      root.querySelector('[data-rr-prev]')?.addEventListener('click',()=>move(Math.max(0,track.scrollLeft-step())));
      root.querySelector('[data-rr-next]')?.addEventListener('click',()=>move(Math.min(track.scrollWidth-track.clientWidth,track.scrollLeft+step())));
      track.addEventListener('scroll',sync,{passive:true});
      new ResizeObserver(sync).observe(track);
      root.addEventListener('rr:visible',sync);
      sync();
    });
    scope.querySelectorAll('[data-rr-tabs]').forEach(root => {
      if(root.dataset.ready) return;
      root.dataset.ready='true';
      const tabs=[...root.querySelectorAll('[role=tab]')];
      const activate=(tab,focus=false)=>{
        tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;const panel=document.getElementById(t.getAttribute('aria-controls'));panel.hidden=!active;if(active)panel.dispatchEvent(new Event('rr:visible'));});
        if(focus) tab.focus();
      };
      tabs.forEach((tab,index)=>{
        tab.addEventListener('click',()=>activate(tab));
        tab.addEventListener('keydown',e=>{let next=index;if(e.key==='ArrowRight')next=(index+1)%tabs.length;else if(e.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=tabs.length-1;else return;e.preventDefault();activate(tabs[next],true);});
      });
    });
    scope.querySelectorAll('[data-rr-open]').forEach(button=>{
      if(button.dataset.ready)return;button.dataset.ready='true';
      button.addEventListener('click',()=>document.getElementById(button.dataset.rrOpen)?.showModal());
    });
    scope.querySelectorAll('.rr-dialog').forEach(dialog=>{
      if(dialog.dataset.ready)return;dialog.dataset.ready='true';
      dialog.querySelector('[data-rr-close]').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
